import React from 'react';
import {twMerge} from 'tailwind-merge';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
    textClassName?: string;
    gradientClassName?: string;
}

export const GradientBorderButton: React.FC<React.PropsWithChildren<Props>> = ({
    className,
    gradientClassName,
    textClassName,
    children,
    ...props
}) => {
    return (
        <button
            {...props}
            className={twMerge(
                "relative inline-flex h-14 w-full flex-shrink-0 overflow-hidden rounded-2xl p-[2px] font-['Inter'] text-[14px] font-semibold",
                className
            )}
        >
            <span
                className={twMerge(
                    `absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#FF9900_0%,#C000A1_50%,#FF9900_100%)]`,
                    gradientClassName
                )}
            />
            <span
                className={twMerge(
                    'flex h-full w-full cursor-pointer items-center justify-center rounded-[14px] bg-black text-white hover:backdrop-blur-2xl hover:bg-black/80 z-10',
                    textClassName
                )}
            >
                {children}
            </span>
        </button>
    );
};
